// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__V31CG","rootSuccess":"CompleteLink_rootSuccess__3is21","rootFailure":"CompleteLink_rootFailure__Cxejk","isDisabled":"CompleteLink_isDisabled__2IFRz"};